import React, { useMemo, useState, useContext, useEffect } from 'react';

// Components
import LandingPageHeader from 'shared/components/LandingPageHeader';
import LandingPageDetails from 'shared/components/LandingPageDetails';
import HostBanner from 'shared/components/LandingPageCTA/HostBanner';

// Utils
import BravelyData from 'utils/data';
import moment from 'moment';
import { getDateTimeRemaining } from '../../components/Timer';
import { mixpanelEvents, mixpanelTrack } from 'utils/mixpanelHelpers';

// Context
import WebinarsContext from 'webinars/context';

// Helpers
import {
  renderRegistrationBanner,
  JOIN_WINDOW,
  getButtonProps,
} from './helpers';
import { headers } from 'webinars/shared/helpers';

// Styles
import './styles';

const {
  webinars: { VIEW_WEBINAR_LANDING_PAGE },
} = mixpanelEvents;

const WebinarRegistrationPage = () => {
  // States
  const { webinar = {} } = useContext(WebinarsContext);

  const {
    name = 'Bravely Webinar',
    formattedDate,
    contentId,
    scheduledDate,
    encodedId,
    recordingUrl,
    googleLink,
    outlookLink,
  } = webinar;

  const shouldShowTimer = getDateTimeRemaining(scheduledDate) > JOIN_WINDOW;

  const [showTimer, setShowTimer] = useState(shouldShowTimer);
  const isRegistered = BravelyData('isRegistered');
  const isLoggedIn = BravelyData('isLoggedIn');

  const now = new Date();
  const isPast = useMemo(
    () => !scheduledDate || moment(scheduledDate).isBefore(now),
    []
  );

  const fromMailOrCalendar = useMemo(
    () => document.location.search.includes('utm_source=reminder'),
    []
  );

  const isAboutToStart =
    !isPast && getDateTimeRemaining(scheduledDate) < JOIN_WINDOW;

  const commonRegistrationBannerProps = {
    isPast,
    isRegistered,
    isLoggedIn,
    showTimer,
    setShowTimer,
    contentId,
    scheduledDate,
    fromMailOrCalendar,
    encodedId,
    recordingUrl,
    name,
    formattedDate,
    googleLink,
    outlookLink,
  };

  const { text: cta } = getButtonProps({
    isPast,
    isRegistered,
    webinarID: encodedId,
    fromMailOrCalendar,
    recordingUrl,
    countDownTimer: undefined,
    isAboutToStart,
    name,
    formattedDate,
  });

  const userState = isLoggedIn ? 'Logged In' : 'Anonymous';

  useEffect(() => {
    mixpanelTrack(VIEW_WEBINAR_LANDING_PAGE, {
      encodedId,
      name,
      cta,
      userState,
    });
  }, []);

  return (
    <>
      <LandingPageHeader title={name} date={formattedDate} />
      <div className="app-centered">
        <div className="landing-page-banner-wrapper">
          {renderRegistrationBanner({
            bannerType: 'primaryCtaBanner',
            ...commonRegistrationBannerProps,
          })}
        </div>
        <div className="landing-page-details">
          <LandingPageDetails headers={headers} event={webinar} />
          <div className="secondary-cta-banner-wrapper">
            {renderRegistrationBanner({
              bannerType: 'secondaryCtaBanner',
              ...commonRegistrationBannerProps,
            })}
          </div>
          <HostBanner hostDetails={webinar?.hostProfile} />
        </div>
      </div>
    </>
  );
};

export default WebinarRegistrationPage;
